import React from 'react';
import { LoginView } from './LoginView';
import { RedirectToIdp } from './RedirectToIdp';
import { useSiteConfig } from '../config';

export function Login() {
  const siteConfig = useSiteConfig();
  if (siteConfig.idpLogin) {
    return <RedirectToIdp />;
  } else {
    return <LoginView />;
  }
}
